module.exports = __webpack_public_path__ + "img/selected5-min.f97ec897.png";